export const getKGSOperatorLeaseLink = () => {
  return 'https://chasm.kgs.ku.edu/ords/qualified.ogw5.SelectWells';
};

export const getKGSLink = (operatorName, leaseName) => {
  const kgsLink = getKGSOperatorLeaseLink();
  const url = `${kgsLink}?f_l=${leaseName}&f_op=${operatorName}`;

  return encodeURI(url);
};
